import angular from 'angular'

import component from './spinner.component'

let module = angular.module('spinner', [])

.component('appSpinner', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/spinner/index.js